import type { PlacementBackendRuntimeConfig, RequestContext } from '../../types';
import type { RuntimeParams } from '../../create-placement-component/types';

type BuildConfigOverlayInput = {
	placementId: string;
	params: RuntimeParams;
	requestContext: RequestContext;
	baseConfig: PlacementBackendRuntimeConfig;
};

/**
 * Decides which placement stages and message templates to tunnel,
 * and fetches their tunnel config from the local dev server.
 *
 * Currently returns an empty overlay (no tunnelling).
 * TODO: Wire up logic to call new in-app-v2 routes in tunnel http-server
 */
export class TunnelPlacementBackendRuntimeConfigBuilder {
	constructor() {}

	async buildConfigOverlay(
		_input: BuildConfigOverlayInput,
	): Promise<Partial<PlacementBackendRuntimeConfig>> {
		// TODO: Implement selective tunnelling decisions
		// For now, return empty overlay (no changes to base config)

		// Example future implementation:
		// 1. Check which stages to tunnel via shouldTunnelStage(stageName, placementId)
		// 2. Check which templates to tunnel via shouldTunnelTemplate(templateKey, placementId)
		// 3. Fetch tunnel config for selected stages/templates from local server
		// 4. Return partial config with only the tunnelled parts

		return {};
	}
}
